export const pagination_store = {
    pagination_deep : {
        rowsPerPage: 5,
        page: 1,
        sortBy: "insert_at",
        descending: true
    }
}